import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class StaffContactService {
  constructor(private api: ApiService) {}
  getAssociatedContactListByCompanyId(companyId: string) {
    return this.api.post('/contacts/companies-contacts', { companyId: companyId });
  }
  getAssociatedContactListByListingId(propertyId: string) {
    return this.api.get(`/contact-association/by-listing/${propertyId}`);
  }
  deleteAssociatedListingContactByUserId(contactId: string) {
    return this.api.delete(`/contact-association/${contactId}`);
  }
  associateContactWithListingProperty(payload: any) {
    return this.api.post('/contact-association', payload);
  }
  updateAssociatedContactStatusById(contactId: string, payload: any) {
    return this.api.put(`/contact-association/${contactId}`, payload);
  }

  updateContactAssociatedWithContract(payload: any) {
    return this.api.post('/contracts/update-contact', payload);
  }
}
